<template>
  <div>
    <div v-if="!variantChoose && activePlate == null">درحال بارگذاری...</div>
    <div v-if="plates.length > 0 && activePlate != null">
      <Row style="min-height: 300px;">
        <i-col
          :md="16"
          :xs="24"
          class-name="dragarea"
          style="border-right: 1px dashed #eee;overflow-x: auto">
          <Row style="background: rgb(246, 246, 246);padding: 0.5em;">
            <i-col :xs="24">
              <ButtonGroup v-if="activePlate.sides_data.length > 1">
                <Button
                  v-for="side in activePlate.sides_data"
                  :key="side.side_name"
                  :type="(activeSide.id === side.id)?'info':''"
                  @click="activeSide = getSideRatio(side)"
                >{{ side.side_name }}
                </Button>
              </ButtonGroup>
            </i-col>
          </Row>
          <Button
            v-if="activeSide.help.length > 0"
            style="position: absolute;right:10px;bottom: 10px;z-index:9999"
            type="info"
            shape="circle"
            icon="md-help"
            @click="help = true">راهنمای طراحی
          </Button>
          <Row
            :style="`background:url(/system/mock_frames/`+ activeSide.id + `.png);background-size: 100% 100%;width:` + activeSide.frame_width +`px;height:`+ activeSide.frame_height +`px`"
            class-name="drag-container">
            <img
              v-if="activeSide.have_cover == 1"
              :style="`width:` + activeSide.frame_width +`px;height:`+ activeSide.frame_height +`px`"
              :src="`/system/mock_frames/cover_`+ activeSide.id + `.png`"
              class="cover-image"
              alt="cover">
            <div
              :class="`zone-area obj-` + activeSide.zone_type"
              :style="`height:`+ (activeSide.zone_type === 'Rect'? activeSide.zone_height:activeSide.zone_width*2) + `px;width:` + (activeSide.zone_type === 'Rect'? activeSide.zone_width:activeSide.zone_width*2) + `px` + `;left:` + (activeSide.zone_type === 'Rect'? activeSide.zone_x:(activeSide.zone_x-activeSide.zone_width)) + `px`+ `;top:` + (activeSide.zone_type === 'Rect'? activeSide.zone_y:(activeSide.zone_y-activeSide.zone_width)) + `px`"/>

            <Moveable
              v-for="layer in activeLayersForDesigner"
              :key="`layer_` + layer.layer_uid"
              :rotatable="false"
              v-bind="moveable"
              :style="`width: `+(round(layer.width*activeSide.ratio))+`px;height:`+(round(layer.height*activeSide.ratio))+`px;top:0;left:0;transform: matrix(1, 0, 0, 1, 0,0) translate(`+(round(layer.x*activeSide.ratio))+`px, `+(round(layer.y*activeSide.ratio))+`px) rotate(`+layer.rotate+`deg)`"
              class="moveable moveable-item"
              @drag="handleDrag(layer.layer_uid,$event)"
              @resize="handleResize(layer.layer_uid,$event)"
              @rotate="handleRotate(layer.layer_uid,$event)"
            >
              <span><img
                :key="`img_layer_` + layer.layer_uid"
                :src="`/tmp/thumb_` + layer.picture"
                style="width: 100%;height:100%"></span>
            </Moveable>
          </Row>
        </i-col>
        <i-col
          :md="8"
          :xs="24"
          style="padding: 0 10px"
        >
          <Row style="margin-bottom: 10px">
            <ButtonGroup style="width: 100%">
              <Button
                :type="settingSwitch === 0?'success':''"
                style="width: 33.33%"
                @click="settingSwitch = 0">ویرایشگر
              </Button>
              <Button
                :type="settingSwitch === 1?'success':''"
                style="width: 33.33%"
                @click="settingSwitch = 1">توضیحات
              </Button>
              <Button
                :type="settingSwitch === 2?'success':''"
                style="width: 33.33%"
                @click="settingSwitch = 2">پیش‌نمایش
              </Button>
            </ButtonGroup>
          </Row>
          <Row v-if="settingSwitch === 2">
            <img
              v-for="render in mockRenders"
              :key="render"
              :src="render"
              style="width: 100%"
            >
          </Row>
          <Row
            v-if="settingSwitch === 1"
            class-name="helper-desc">
            <div v-if="currentBlank.description.length > 51">
              <h2>توضیحات محصول</h2>
              <p
                style="text-align: right"
                v-html="currentBlank.description"/>
            </div>
            <div v-if="currentBlank.size_helper.length > 10">
              <h2>راهنمای سایز</h2>
              <p
                style="text-align: right"
                v-html="currentBlank.size_helper"/>
            </div>
          </Row>
          <Row v-if="settingSwitch === 0">
            <Alert type="info">{{ activePlate.name }}</Alert>
            <Upload
              :format="['jpg','jpeg','png']"
              :max-size="30000"
              :on-exceeded-size="uploadMax"
              :on-format-error="formatError"
              :action="`/api/designer/upload/` + activePlate.uid + `/` + String(activeSide.id)"
              :on-success="successUpload"
              :key="'upload_' + activePlate.uid"
              multiple
              type="drag"
            >
              <div style="padding: 20px 0">
                <Icon
                  type="ios-cloud-upload"
                  size="52"
                  style="color: #3399ff"/>
                <p> افزودن تصویر
                  <br>
                  <small>(تصویر را بکشید یا کلیک کنید)</small>
                  (حداکثر  png,jpg 30MB)</p>
              </div>
            </Upload>
            <Row
              v-for="layer in activeLayersList"
              :key="`layer_` + activeLayersList.length + layer.layer_uid"
              class="plate-layer"
            >
              <div class="layer-btn">
                <Button
                  size="large"
                  icon="md-trash"
                  color="gray"
                  @click="removeLayer(layer.layer_uid)"/>
                <Button
                  size="large"
                  icon="ios-copy-outline"
                  color="gray"
                  @click="duplicateLayer(layer.layer_uid)"/>
                <Button
                  :icon="(typeof layer.hide === 'undefined' || !layer.hide)?`md-eye`:`md-eye-off`"
                  size="large"
                  color="gray"
                  @click="toggleLayer(layer.layer_uid)"/>
                <Button
                  icon="md-redo"
                  size="large"
                  color="gray"
                  @click="rotateLayer(layer.layer_uid)"/>
              </div>
              <img
                :src="`/tmp/thumb_` + layer.picture"
                class="layer-img">
            </Row>
            <Row
              type="flex"
              style="margin-top: 10px;margin-bottom : 10px">
              <i-col :xs="12">
                <i-col
                  :xs="18"
                  :sm="18">
                  <i-input
                    v-model.number="activePlate.quantity"
                    label="تعداد"
                    min="1"
                    type="number"
                    @on-change="changeQuantity(activePlate.uid)"
                  />
                </i-col>
                <i-col
                  :xs="6"
                  :sm="6"
                  style="margin-top: 5px;margin-bottom : 5px">
                  تعداد:
                </i-col>
              </i-col>
              <i-col
                :xs="12"
                style="padding:0 10px 0 0">
                <Button
                  type="success"
                  style="width: 100%"
                  @click="doCustomSync">افزودن به سبد</Button>
              </i-col>
            </Row>
            <Row
              v-if="platePrintPrice(activePlate, currentSides, price_list) > 0"
              type="flex"
              style="margin-top: 10px;margin-bottom : 10px">
              <i-col
                :xs="12"
                :style="`padding-top: 5px;` + (activePlate.sides.length > 0?``:` font-weight: bold;`)">
                قیمت (بدون چاپ)
                <b>{{ moneyFormat(platePriceWithoutPrint(activePlate, currentSides, price_list)) }}</b>
                تومان
              </i-col>
              <i-col
                :xs="12"
                :style="`padding-top: 5px;` + (activePlate.sides.length > 0?` font-weight: bold;`:``)">
                قیمت (با چاپ)
                <b>{{ moneyFormat(platePrintPrice(activePlate, currentSides, price_list)) }}</b>
                تومان
              </i-col>
            </Row>
            <Row
              v-else
              type="flex"
              style="margin-top: 10px;margin-bottom : 10px">
              <i-col
                :xs="24"
                style="padding-top: 5px;text-align: center">
                قیمت {{ platePriceLabel(activePlate,currentSides) }}
                <b>{{ moneyFormat(platePrice(activePlate, currentSides, price_list)) }}</b>
                تومان
              </i-col>
            </Row>
            <Row v-if="blankPriceList.length > 1">
              <Collapse simple>
                <Panel name="1">
                  <b>قیمت تیراژ</b>
                  <p slot="content">
                    <Row
                      v-for="price in blankPriceList"
                      :key="`to_quantity_`+price.to"
                      style="padding:0.33em 0"
                    >
                      {{ price.title }}
                      <b>{{ moneyFormat(platePrice(price.plate, currentSides, price_list)) }}</b>
                      تومان
                    </Row>
                  </p>
                </Panel>
              </Collapse>
            </Row>
          </Row>
        </i-col>
      </Row>
      <Divider
        :dashed="true"
        orientation="right"/>
      <Row style="padding: 5px">
        <i-col
          :xs="8"
          :md="4"
          class-name="bottom-area"
        >
          <div
            class="bottom-boxes"
            @click="variantChoose = true">
            <Icon
              :size="66"
              style="margin-top: 12px;"
              type="md-add-circle"
              color="gray"/>
          </div>
        </i-col>
        <i-col
          v-for="(plate,id) in plates"
          :xs="8"
          :md="4"
          :key="`plate_` + id"
          class-name="bottom-area">
          <Button
            type="error"
            icon="md-close"
            style="position: absolute;top:0;right:0"
            @click="removePlate(plate.uid)"/>
          <div
            :class="`bottom-boxes ` + (plate.uid === activePlate.uid?'active':'')"
            @click="loadPlate(plate)">
            <img
              :src="(plate.uid === loadingPlateUID?'/static_designers/loading.gif':`https://chapchi.com/api/designer/render/`+plate.uid+`/`+plate.sides_data[0].id+`/`+getFirstMock(plate)+`?rand=`+rand)"
              style="max-height: 90px"
            >
          </div>
        </i-col>

        <i-col
          v-if="plates.length > 0"
          :xs="8"
          :md="4"
          class-name="bottom-area"
        >
          <router-link to="/basket">
            <div
              class="bottom-boxes">
              <Icon
                :size="66"
                style="margin-top: 12px;"
                type="ios-basket-outline"
                color="green"/>
            </div>
          </router-link>
        </i-col>
      </Row>
    </div>
    <VariantSelector
      v-if="variantChoose"
      :stock="stock"
      @add="AddPlate"
      @close="Close"/>
    <Modal
      v-model="help"
      scrollable
      cancel-text=""
      title="راهنمای طراحی">
      <div
        v-if="activeSide !== null"
        style="padding: 5px"
        v-html="activeSide.help"/>
    </Modal>
  </div>
</template>
<script>
import VariantSelector from './VariantSelector'
import Moveable from 'vue-moveable'

export default {
  name: 'Designer',
  components: {
    Moveable,
    VariantSelector
  },
  data () {
    return {
      help: false,
      variantChoose: false,
      plates: [],
      rand: 0.22,
      activeSide: {},
      syncQueue: {
        position: {},
        rotate: {},
        size: {}
      },
      reseller: false,
      layersCache: {},
      loadingPlateUID: null,
      settingSwitch: 0,
      mocks: [],
      price_list: [],
      additional: [],
      stock: [],
      sides: [],
      blanks: [],
      activeLayers: [],
      activePlate: null,
      moveable: {
        draggable: true,
        throttleDrag: 0,
        resizable: true,
        throttleResize: 1,
        keepRatio: true,
        scalable: false,
        throttleScale: 0,
        rotatable: true,
        throttleRotate: 0,
        pinchable: false, // ["draggable", "resizable", "scalable", "rotatable"]
        origin: false
      }
    }
  },
  computed: {
    currentSides () {
      let sides = []
      this.activeLayers.forEach(al => {
        sides.push(al.side_id)
      })
      return this.sides.filter(s => {
        return sides.includes(s.id)
      })
    },
    blankPriceList () {
      let prices = this.price_list.filter(pl => {
        return pl.blank_id === this.activePlate.blanks_id && pl.blank_type === this.activePlate.blanks_type && pl.blank_size === this.activePlate.blanks_size && pl.blank_color === this.activePlate.color_id
      })

      if (prices.length <= 1) {
        return []
      }
      prices = prices.sort(function (a, b) {
        return a.to_quantity - b.to_quantity
      })
      prices = prices.map((p, k) => {
        p.to = p.to_quantity
        p.title = ''

        if (k === 0) {
          p.title = 'کمتر از ' + prices[k + 1].to_quantity + ' عدد'
        } else if (k === prices.length - 1) {
          p.title = p.to_quantity + ' عدد و بیشتر'
        } else {
          p.title = 'از ' + p.to_quantity + ' عدد ' +
              'تا ' + (prices[k + 1].to_quantity - 1) + ' عدد'
        }
        let ap = Object.assign({}, this.activePlate)
        ap.quantity = p.to_quantity
        ap.additional_parameters = []
        p.plate = ap
        return p
      })
      return prices
    },
    ratio () {
      if (window.screen.width < this.activeSide.frame_width) {
        return window.screen.width < this.activeSide.frame_width
      }
      return 1
    },
    activeLayersForDesigner () {
      return this.activeLayers.filter(l => l.side_id === this.activeSide.id && (typeof l.hide === 'undefined' || !l.hide))
    },
    activeLayersList () {
      return this.activeLayers.filter(l => l.side_id === this.activeSide.id)
    },
    currentBlank () {
      let i = this.blanks.find(b => b.blanks_id === this.activePlate.blanks_id)
      if (typeof i === 'undefined') {
        return {description: '', size_helper: ''}
      }
      return i
    },
    mockRenders () {
      let out = []
      this.activePlate.sides_data.forEach((mf) => {
        this.getMocks(mf.id).forEach((mk) => {
          out.push('https://chapchi.com/api/designer/render/' + this.activePlate.uid + `/` + mf.id + `/` + mk.id + `?rand=` + this.rand)
        })
      })
      return out
    }
  },
  mounted () {
    this.reseller = (window.location.search.indexOf('reseller') > -1)
    this.loadData()
    // get mocks
    this.axios.get('/designer/mocks').then(response => {
      this.mocks = response.data
    }).catch(() => {
      this.showError('خطا در ارتباط')
    })

    // sync layers
    this.Sync()
  },
  methods: {
    doCustomSync () {
      this.$Message.info('همگام سازی انجام شد')
      this.Sync()
    },
    Sync () {
      if (typeof window.syncInterval !== 'undefined') {
        clearInterval(window.syncInterval)
      }
      this.syncQueueAction()
      window.syncInterval = setInterval(this.syncQueueAction, 6000)
    },
    getLayerIDByUID (layerUID) {
      if (typeof this.layersCache[layerUID] !== 'undefined') {
        return this.layersCache[layerUID]
      }
      this.layersCache[layerUID] = this.activeLayers.findIndex(al => al.layer_uid === layerUID)
      return this.layersCache[layerUID]
    },
    round (a) {
      return Math.round(a)
    },
    uploadMax () {
      this.showError('حجم فایل زیاد است. حداکثر ۳۰ مگابایت')
    },
    formatError () {
      this.showError('فرمت نامعتبر است، لطفا از png یا jpg استفاده کنید')
    },
    Close () {
      if (this.plates.length === 0) {
        this.showError('انتخاب یک محصول برای ورود به بخش طراحی الزامی است')
      } else {
        this.variantChoose = false
      }
    },
    AddPlate () {
      this.variantChoose = false
      this.loadPlates()
    },
    getSideRatio (side) {
      let org = Object.assign({}, side)
      let ratio = window.screen.width / org.frame_width
      side.inverseRatio = org.frame_width / window.screen.width
      if (ratio < 1) {
        side.frame_width = Math.round(side.frame_width * ratio)
        side.frame_height = Math.round(side.frame_height * ratio)
        side.zone_width = Math.round(side.zone_width * ratio)
        side.zone_height = Math.round(side.zone_height * ratio)
        side.zone_x = Math.round(side.zone_x * ratio)
        side.zone_y = Math.round(side.zone_y * ratio)
        side.ratio = ratio
      } else {
        side.ratio = 1
        side.inverseRatio = 1
      }
      return side
    },
    loadPlates () {
      this.axios.get('/designer/plates').then(response => {
        this.plates = response.data.map(p => {
          p.sides = p.sides.split(',').map(s => Number(s))
          return p
        })
        if (this.plates.length === 0) {
          this.variantChoose = true
        } else {
          this.loadPlate(this.plates[0])
        }
      }).catch(() => {
        this.showError('خطا در ارتباط')
      })
    },
    async loadPlate (plate) {
      this.loadingPlateUID = plate.uid
      if (plate.sides_data === 0) {
        this.showError('خطایی رخ داده‌است')
        return
      }

      let side = plate.sides_data.find(sd => sd.id === this.activeSide.id)
      if (typeof side === 'undefined') {
        side = plate.sides_data[0]
      }
      if (typeof side.ratio === 'undefined') {
        this.activeSide = this.getSideRatio(side)
      } else {
        this.activeSide = side
      }
      return new Promise(async (resolve, reject) => {
        this.axios.get('/designer/layers/' + plate.uid).then(response => {
          this.activePlate = plate
          let sides = []
          this.activeLayers = response.data.data.map(l => {
            if (!sides.includes(l.side_id)) {
              sides.push(l.side_id)
            }
            l.hide = false
            return l
          })
          this.activePlate.sides = sides
        }).catch(() => {
          this.showError('خطا در ارتباط')
        }).finally(() => {
          this.loadingPlateUID = null
          return resolve()
        })
      })
    },
    async successUpload (res, file, fileList) {
      let i = this.plates.findIndex(p => p.uid === fileList[0].response.plate_uid)
      /* if (i > -1) {
            if (typeof this.plates[i].layers === 'undefined') {
              this.plates[i].layers = []
            }
            this.plates[i].layers.push(this.getSideRatio(fileList[0].response))
          } */
      await this.loadPlate(this.plates[i])
      this.rand = Math.random()
    },
    handleRotate (layerUID, {target, dist, transform}) {
      // target.style.transform = transform
    },
    handleDrag (layerUID, {target, transform}) {
      // Convert matrix() transform() to x,y
      let data = transform.replace(/[ ()]/g, '').replace('matrix', '').replace('translate', ',').replace(/px/g, '')
      data = data.split(',')
      let angle = this.activeLayers[this.getLayerIDByUID(layerUID)].rotate
      let x = 0
      let y = 0
      switch (angle) {
        case 90:
          x = Number(data[5]) - Number(data[7])
          y = Number(data[4]) - Number(data[6]) * -1
          break
        case 270:
          x = Number(data[5]) - Number(data[7]) * -1
          y = Number(data[4]) - Number(data[6])
          break
        case 180:
          x = Number(data[4]) - Number(data[6])
          y = Number(data[5]) - Number(data[7])
          break
        default:
          x = Number(data[4]) + Number(data[6])
          y = Number(data[5]) + Number(data[7])
      }
      this.activeLayers[this.getLayerIDByUID(layerUID)].x = x * this.activeSide.inverseRatio
      this.activeLayers[this.getLayerIDByUID(layerUID)].y = y * this.activeSide.inverseRatio
      // Put x,y to sync Queue
      this.syncQueue.position[layerUID] = {
        x: Math.round(x * this.activeSide.inverseRatio),
        y: Math.round(y * this.activeSide.inverseRatio)
      }

      target.style.transform = 'transform: matrix(1, 0, 0, 1, 0, 0) translate(' + x + 'px, ' + y + 'px) rotate(' + angle + 'deg)'
    },
    handleResize (layerUID, {
      target, width, height, delta
    }) {
      this.activeLayers[this.getLayerIDByUID(layerUID)].width = width * this.activeSide.inverseRatio
      this.activeLayers[this.getLayerIDByUID(layerUID)].height = height * this.activeSide.inverseRatio
      // Put width,height to sync Queue
      this.syncQueue.size[layerUID] = {
        width: Math.round(width * this.activeSide.inverseRatio),
        height: Math.round(height * this.activeSide.inverseRatio)
      }
      delta[0] && (target.style.width = `${width}px`)
      delta[1] && (target.style.height = `${height}px`)
    },
    rotateLayer (layerUID) {
      let rotate = this.activeLayers[this.getLayerIDByUID(layerUID)].rotate
      if (rotate !== 0 && rotate % 90 !== 0) {
        rotate = 0
      }
      rotate += 90
      if (rotate === 360) {
        rotate = 0
      }
      this.syncQueue.rotate[layerUID] = rotate
      this.activeLayers[this.getLayerIDByUID(layerUID)].rotate = rotate
    },
    removeLayer (layerUID) {
      // delete layer
      this.axios.delete('/designer/layer/' + layerUID).then(() => {
        this.activeLayers = this.activeLayers.filter(l => l.layer_uid !== layerUID)
        this.rand = Math.random()
      }).catch((err) => {
        if (typeof err.response.data.message !== 'undefined') {
          this.showError(err.response.data.message)
        } else {
          this.showError('خطا در همگام‌سازی لایه‌ها با سرور')
        }
      })
    },
    duplicateLayer (layerUID) {
      let i = this.activeLayers.findIndex(l => l.layer_uid === layerUID)
      if (i === -1) {
        this.showError('ناتوان در یافتن لایه')
        return
      }
      // delete layer
      this.axios.post('/designer/layer/duplicate/' + layerUID, {}).then((response) => {
        let item = Object.assign({}, this.activeLayers[i])
        item.layer_uid = response.data.content
        this.activeLayers.push(item)
      }).catch((err) => {
        if (typeof err.response.data.message !== 'undefined') {
          this.showError(err.response.data.message)
        } else {
          this.showError('خطا در همگام‌سازی لایه‌ها با سرور')
        }
      })
    },
    toggleLayer (layerUID) {
      let i = this.activeLayers.findIndex(l => l.layer_uid === layerUID)
      if (i > -1) {
        if (typeof this.activeLayers[i].hide === 'undefined') {
          this.activeLayers[i].hide = true
        } else {
          this.activeLayers[i].hide = !this.activeLayers[i].hide
        }
      }
    },
    getFirstMock (plate) {
      let m = this.mocks.find(mock => mock.side === plate.sides_data[0].id && mock.color_id === plate.color_id && mock.size_id === plate.blanks_size && mock.type_id === plate.blanks_type && mock.blanks_id === plate.blanks_id)
      if (typeof m === 'undefined') {
        return 0
      }
      return m.id
    },
    getMocks (side) {
      let m = this.mocks.filter(mock => mock.side === side && mock.color_id === this.activePlate.color_id && mock.size_id === this.activePlate.blanks_size && mock.type_id === this.activePlate.blanks_type && mock.blanks_id === this.activePlate.blanks_id)
      if (typeof m === 'undefined') {
        return []
      }
      return m
    },
    loadData () {
      this.axios.get('/designer/data' + (this.reseller ? '?reseller=1' : '')).then(response => {
        this.price_list = this.reseller ? response.data.rp_list : response.data.price_list
        this.blanks = response.data.blanks
        this.stock = response.data.stock
        this.additional = response.data.additional.map(ad => {
          ad.colors = ad.colors.length > 0 ? ad.colors.split(',').map(i => Number(i)) : []
          ad.sizes = ad.sizes.length > 0 ? ad.sizes.split(',').map(i => Number(i)) : []
          ad.types = ad.types.length > 0 ? ad.types.split(',').map(i => Number(i)) : []
          return ad
        })
        this.sides = response.data.sides
        this.loadPlates()
      }).catch(() => {
        this.showError('خطا در ارتباط، صفحه را مجددا بارگذاری کنید')
      })
    },
    removePlate (plateUID) {
      // delete plate
      this.axios.delete('/designer/plate/' + plateUID).then((response) => {
        this.plates = this.plates.filter(p => p.uid !== plateUID)
        if (this.plates.length === 0) {
          this.variantChoose = true
        }
      }).catch((err) => {
        if (typeof err.response.data.message !== 'undefined') {
          this.showError(err.response.data.message)
        } else {
          this.showError('خطا در همگام‌سازی لایه‌ها با سرور')
        }
      })
    },
    changeQuantity (uid) {
      this.axios.put('/designer/plate', {
        uid: uid,
        quantity: this.activePlate.quantity
      }).catch(() => {
        this.showError('خطا در همگام‌سازی لایه‌ها با سرور')
      })
    },
    platePrintPrice (plate, sides, priceList) {
      let price = 0
      // add sides prices
      plate.sides_data.forEach(ps => {
        price += ps.print_price
      })
      if (price === 0) {
        return 0
      }

      if (plate.sides.length > 0) {
        return this.platePrice(plate, sides, priceList)
      }

      price = this.platePriceWithoutPrint(plate, sides, priceList)
      // add sides prices
      let pricePlate = plate.sides_data.find(ps => ps.print_price > 0)
      if (typeof pricePlate !== 'undefined') {
        return price + (pricePlate.print_price / 10)
      }
      return price
    },
    platePriceLabel (plate, sides) {
      let price = 0
      // add sides prices
      plate.sides_data.forEach(ps => {
        price += ps.print_price
      })
      if (price === 0) {
        return ''
      }

      price = 0
      // add sides prices
      sides.forEach(ps => {
        if (plate.sides.includes(ps.id)) {
          price += ps.print_price
        }
      })

      if (price > 0) {
        return '(با چاپ)'
      }

      return '(بدون چاپ)'
    },
    syncQueueAction () {
      let queue = Object.assign({}, this.syncQueue)
      this.syncQueue = {
        position: {},
        rotate: {},
        size: {}
      }
      if (this.isEmpty(queue.position) && this.isEmpty(queue.rotate) && this.isEmpty(queue.size)) {
        return
      }
      this.axios.post('/designer/sync_layers', queue).then(() => {
        this.rand = Math.random()
        this.$Message.info('همگام سازی انجام شد')
      }).catch(() => {
        this.showError('خطا در همگام‌سازی لایه‌ها با سرور')
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  h1, h2 {
    font-weight: normal;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    display: inline-block;
    margin: 0 10px;
  }

  a {
    color: #42b983;
  }

  .bottom-boxes {
    cursor: pointer;
    min-height: 100px;
    border: 1px solid #eeeeee;
    border-radius: 5px;
    margin-top: 5px;
    box-shadow: 1px 1px 0 #eeeeee;
    padding: 5px 15px;
    height: 74px;
    box-sizing: border-box;
  }

  .bottom-boxes:hover {
    border: 1px solid #3cb1ac;
  }

  .bottom-boxes.active {
    border: 1px solid #49aeb1;
  }

  .bottom-area {
    padding: 3px;
  }

  .plate-layer {
    border: 1px solid #eeeeee;
    border-radius: 5px;
    margin-top: 5px;
    box-shadow: 1px 1px 0 #eeeeee;
    padding: 5px 15px;
    height: 74px;
    box-sizing: border-box;
  }

  .plate-layer:hover {
    background: #f6f6f6;
  }

  .layer-img {
    height: 100%;
    float: left;
    box-shadow: 3px 3px 0 #cacaca;
  }

  .layer-btn {
    margin-top: 10px;
    float: right;
  }

  .-mouse-pointer {
    cursor: pointer;
  }

  .drag-container {
    direction: ltr;
    position: relative;
    margin: 0 auto;
  }

  div[data-able-draggable=true] {
    transition: all 660ms ease;
  }

  .zone-area {
    position: absolute;
    background-color: rgba(0, 0, 0, 0.12);
    -webkit-transition: ease-out 440ms;
    -moz-transition: ease-out 440ms;
    -ms-transition: ease-out 440ms;
    -o-transition: ease-out 440ms;
    transition: ease-out 440ms;
    z-index: 9991;
    position: absolute;
    animation-duration: 444ms;
    animation-name: blink;
    animation-iteration-count: infinite;
    animation-direction: alternate;
    -webkit-animation: blink 444ms infinite; /* Safari and Chrome */
  }

  .drag-container:hover .zone-area {
    z-index: 1;
  }

  .moveable {
    z-index: 999999;
  }

  .moveable-line,
  .moveable-rotation-line,
  .drag-container,
  .cover-image,
  .moveable-control,
  .moveable-direction,
  .moveable-nw {
    -webkit-transition: linear 440ms;
    -moz-transition: linear 440ms;
    -ms-transition: linear 440ms;
    -o-transition: linear 440ms;
    transition: linear 440ms;
  }

  .drag-container:hover .cover-image {
    display: none;
    animation-name: hide_cover;
    animation-duration: 3s;
  }

  @keyframes hide_cover {
    0% {
      display: none;
    }
    100% {
      display: none;
    }
  }

  .helper-desc {
    overflow-x: hidden;
  }

  .helper-desc img {
    width: 100%;
    max-width: 100%;
  }

  .cover-image {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    z-index: 9991;
  }

  .obj-Circle {
    border-radius: 100%;
  }

  .vdr-stic {
    z-index: 99;
  }

  .text-shadow {
    text-shadow: 1px 1px 2px #ffffff;
  }

  .selected-color {
    -webkit-box-shadow: 0 0 14px #f00000 !important;
    -moz-box-shadow: 0 0 14px #f00000 !important;
    box-shadow: 0 0 14px #f00000 !important;
  }

  .moveable-item {
    z-index: 999;
    user-select: none;
    position: absolute;
  }

  @keyframes blink {
    from {
      border: 1px dashed red;
    }
    to {
      border: 0;
    }
  }

  @-webkit-keyframes blink {
    from {
      border: 1px dashed red;
    }
    to {
      border: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Designer.vue